import { render, staticRenderFns } from "./HomeServiziCarousel.vue?vue&type=template&id=6249f6fa&"
import script from "./HomeServiziCarousel.vue?vue&type=script&lang=js&"
export * from "./HomeServiziCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports